import { ShieldAlert } from "lucide-react";

// Redline staff tiers. platform_admin runs the platform alongside the owner; onboarding_admin
// sets up new communities. Neither is the money layer (billing stays super_admin only).
export const PLATFORM_ROLES = ["super_admin", "platform_admin", "onboarding_admin"];
export const PORTFOLIO_ADMIN_ROLES = ["super_admin", "platform_admin"];

// iter252/H6 — these pages used to `return null` for anyone but a super admin, so a
// platform admin landed on a completely blank screen with no explanation (their sidebar
// linked straight to it). Never render nothing: say what happened and where to go.
export function NoAccess({ page = "This page", hint = "" }) {
  return (
    <div data-testid="no-access" className="max-w-lg mx-auto mt-16 text-center">
      <div className="mx-auto h-12 w-12 rounded-2xl bg-sand-100 flex items-center justify-center">
        <ShieldAlert className="h-6 w-6 text-ink/40" strokeWidth={1.75} />
      </div>
      <h1 className="font-heading font-extrabold text-2xl text-ink mt-4">{page} isn&apos;t available to your role</h1>
      <p className="text-sm text-ink/60 mt-2">
        {hint || "Your account doesn't include this area. If you need it, ask an Ask Redline owner to grant access."}
      </p>
    </div>
  );
}
